/**
 * 
 * @description This query is used to track the urls of the properties shared to the agents by whatsapp.
 * @returns string
 * 
 */

export const UtmProperties = "utm_source=whatsapp_botton&utm_medium=boton_ws&utm_campaign=vista_propiedad";